// Auto-generated skeleton for CraftsmanTask

import { Person } from "./Person";
import { CraftsmanTaskStatus } from "./CraftsmanTaskStatus";
import { CraftsmanTaskStatusText } from "./CraftsmanTaskStatusText";
import { Team } from "./Team";
import { CraftsmanTaskProcess } from "./CraftsmanTaskProcess";
import { CraftsmanTaskType } from "./CraftsmanTaskType";
import { Building } from "./Building";
import { Unit } from "./Unit";
import { DocumentContainer } from "./DocumentContainer";
import { CraftsmanTaskPerson } from "./CraftsmanTaskPerson";
import { Record } from "./Record";
import { Report } from "./Report";
import { Cis } from "./Cis";
import { Task } from "./Task";

export const CraftsmanTask: Api.CraftsmanTask = {
  id: 0,
  hp_id: null,
  subject_type: null,
  subject: null,
  craftsman_person_id: 0,
  craftsman_person: Person,
  status_id: 0,
  status: CraftsmanTaskStatus,
  status_text: CraftsmanTaskStatusText,
  team_id: 0,
  team: Team,
  to_occur: '',
  deadline: '',
  finished: null,
  process_id: 0,
  process: CraftsmanTaskProcess,
  type_id: 0,
  type: CraftsmanTaskType,
  estimated_price: null,
  bill_price: null,
  first_building: Building,
  first_unit: Unit,
  synced_at: null,
  created: null,
  updated: null,
  documents: [DocumentContainer],
  persons: [CraftsmanTaskPerson],
  units: [Unit],
  records: [Record],
  reports: [Report],
  buildings: [Building],
  cis: [Cis],
  tasks: [Task],
};

